import React, { useState, useEffect, useRef } from 'react';

//Dependencies.
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { v4 } from 'uuid';
import { useNavigate } from 'react-router-dom';

//Function.
   //Dispatch.
   import { authenticateAndAddUserToFS } from '../../../slices/allUsersSlice';


import "./SignUpForm.styles.css";

const SignUpForm = ({setModal, modal}) => {
   const [imageDetails, setImageDetails] = useState({ addImage: "", imageSource: "", imageFile: null });

   const dispatch = useDispatch();
   const navigate = useNavigate();

   const userNameRef = useRef();
   const passwordRef = useRef();
   const emailRef = useRef();
   const imageLinkRef = useRef();

   useEffect(() => {
      
      return () => {
         setImageDetails({ addImage: "", imageSource: "", imageFile: null });
      };
   }, []);

   async function handleSubmission(e) {
      e.preventDefault();
      const _userID = `${userNameRef.current.value}-${v4()}`;

      const newUserObject = {
         _userID,
         username: userNameRef.current.value,
         email: emailRef.current.value,
         password: passwordRef.current.value,
         imageSource: imageDetails.imageSource || null,
         imageLink: imageDetails.imageFile ?
            imageDetails.imageFile
            :
            (imageLinkRef.current ? imageLinkRef.current.value : null),
         record: { wins: 0, losses: 0, ties: 0, winPct: 0 }
      }

      await dispatch(authenticateAndAddUserToFS({ ...newUserObject }));

      navigate(`/member/_userID/${_userID}/home`);
      
      setModal(!modal);
   }

   return (
      <Form style={{
         border: "3.5px solid red",
         borderRadius: "15px"
      }} className='signUpForm' onSubmit={handleSubmission}>
         <FormGroup>
            <Label htmlFor='username'>USERNAME</Label>
            <Input type='text' id='username' required style={{border: "3px solid black"}} defaultValue="IFF-User1" innerRef={userNameRef} />
         </FormGroup>
         <FormGroup>
            <Label htmlFor='password'>PASSWORD</Label>
            <Input type='password' id='password' required style={{border: "3px solid black"}} defaultValue="IFF-User1" innerRef={passwordRef} />
         </FormGroup>
         <FormGroup>
            <Label htmlFor='email'>EMAIL</Label>
            <Input type='email' id='email' required style={{border: "3px solid black"}} defaultValue="IFF-User1@gmail.com" innerRef={emailRef} />
         </FormGroup>
         
         {/* START QUESTION: ADD AN IMAGE. */}
         <FormGroup>
            <Row>
               <Col>DO YOU WANT TO ADD AN IMAGE?</Col>
            </Row>
            <Row>
               <Col sm={5}>
                  <Label htmlFor='yes'>YES</Label>
               </Col>
               <Col sm={7}>
                  <Input type='radio' name='addImage' value='yes' id='yes' required onChange={e => setImageDetails(prvImageDetails => {
                     return { ...prvImageDetails, addImage: e.target.value }
                  })} style={{border: "3px solid black"}} />
               </Col>
            </Row>
            <Row>
               <Col sm={5}>
                  <Label htmlFor='no'>NO</Label>
               </Col>
               <Col sm={7}>
                  <Input type='radio' name='addImage' value='no' id='no' onChange={e => setImageDetails(prvImageDetails => {
                     return { ...prvImageDetails, addImage: e.target.value }
                  })} style={{border: "3px solid black"}}  />
               </Col>
            </Row>
         </FormGroup>
         {/* END QUESTION: ADD AN IMAGE. */}
         
         {/* START: IMAGE SOURCE. */}
         {
            (imageDetails.addImage === "yes")
            &&
            <FormGroup>
               <Row>
                  <Col><strong>Where will you be getting the image from?</strong></Col>
               </Row>
               <Row>
                  <Col sm={5}>
                     <Label htmlFor='computer'>From My Computer</Label>
                  </Col>
                  <Col sm={7}>
                     <Input type='radio' id='computer' name='imageSource' value='computer' style={{border: '3px solid black'}} 
                     onChange={e => setImageDetails(prvImageDetails => {
                        return { ...prvImageDetails, imageSource: e.target.value };
                     })} required />
                  </Col>
               </Row>
               <Row>
                  <Col sm={5}>
                     <Label htmlFor='internet'>Online URL from Internet</Label>
                  </Col>
                  <Col sm={7}>
                     <Input type='radio' id='internet' name='imageSource' value='online' style={{border: '3px solid black'}}
                     onChange={e => setImageDetails(prvImageDetails => {
                        return { ...prvImageDetails, imageSource: e.target.value };
                     })} />
                  </Col>
               </Row>
            </FormGroup>
         }
         {/* END: IMAGE SOURCE. */}
         
         { /* START: ADD LINK */ }
         {
            (imageDetails.addImage === "yes" && imageDetails.imageSource === "computer")
            &&
            <FormGroup>
               <Label htmlFor='fileURL'>DOWNLOAD FILE FROM COMPUTER.</Label>
                  <Input type='file' 
                     style={{ border: "3px solid black" }} onChange={e => setImageDetails({ ...imageDetails, imageFile: e.target.files[0] })} required
                  />
            </FormGroup>
         }
         
         {
            (imageDetails.addImage === "yes" && imageDetails.imageSource === "online")
            &&
            <FormGroup>
               <Label htmlFor='onlineURL'>COPY/PASTE IMAGE URL ONLINE.</Label>
               <Input type='text'
               style={{border: "3px solid black"}}
               defaultValue="https://images.unsplash.com/flagged/photo-1623506450155-2b29003592d9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" innerRef={imageLinkRef} required />
            </FormGroup>
         }
         { /* END: ADD LINK */ }
               
         <div className="d-grid gap-2">
            <button className="btn btn-danger" type="submit">SIGN UP!!!</button>
         </div>
      </Form>
   )
}

export default SignUpForm